export const IS_GIFT_CARD_GLOBAL = true;